// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fctl-login-command-modal__clipboard-copy .pf-v6-c-button {
  --pf-v6-c-button--ScaleX: 0.95;
  --pf-v6-c-button--ScaleY: 0.95;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/components/modals/LoginCommandModal/LoginCommandModal.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC","sourcesContent":[".fctl-login-command-modal__clipboard-copy .pf-v6-c-button {\n  --pf-v6-c-button--ScaleX: 0.95;\n  --pf-v6-c-button--ScaleY: 0.95;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
